
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'indexOf'
})
export class IndexOfPipe implements PipeTransform {
    transform(value: any[], args: any[]): number {
        return value.indexOf(args[0])
    }
}